import { generateInitialState, createTableSlice } from './tableSlice';

const relationshipContactsTableInitialState = generateInitialState();
export const relationshipContactsTableSlice = createTableSlice(
	'relationshipContactsTable',
	relationshipContactsTableInitialState,
);

export const {
	setPageAfter,
	setRowsPerPage,
	setSearchValue,
	setSearchText,
	setOrderBy,
	setOrder,
	setPage,
	setRows,
	resetSearchFields,
	changeRowsPerPage,
	requestSort,
	changePage,
	resetAllPages,
	onOrderChange,
	setSelected,
	triggerRefresh,
} = relationshipContactsTableSlice.actions;

export default relationshipContactsTableSlice.reducer;
